import { useQuery } from "@tanstack/react-query";
import { productsApi } from "../api/productsApi";
import { productsKeys } from "../api/productsKeys";

export const useProducts = (params) =>
  useQuery({
    queryKey: productsKeys.list(params),
    queryFn: () => productsApi.list(params),
  });
